import React, { useState } from "react";
import Header from "../../../common/Header";
import { Box, Button } from "@mui/material";
import style from "./bankDetails.module.css";
import { useForm } from "react-hook-form";
import { ReactComponent as BankIcon } from "../../../assets/benefits/bank-icon.svg";

export default function BankDetails() {
  const [isBankDetials, setIsBankDetials] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => console.log(data);
  return (
    <Box
      style={{
        position: "fixed",
        width: "100svw",
      }}
    >
      <Header header="Bank Details" />
      {!isBankDetials ? (
        bankDetailsIsEmpty()
      ) : (
        <Box
          sx={{
            padding: "1rem",
            height: "91vh",
            position: "relative",
          }}
        >
          <h4 className={style.bank_desc}>
            Your remuneration will be settled into the following account.
          </h4>
          <form
            onSubmit={handleSubmit(onSubmit)}
            style={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box className={style.boxContainer}>
              <p>Bank Name</p>
              <input defaultValue="HDFC Bank" {...register("bankName")} />
            </Box>
            <Box className={style.boxContainer}>
              <p>Bank Account Number</p>
              <input defaultValue="7854344232121" {...register("bankNumber")} />
            </Box>
            <Box className={style.boxContainer}>
              <p>IFCS Code</p>
              <input defaultValue="HDFC****" {...register("bankIFCSCode")} />
            </Box>
          </form>
          <Box
            sx={{
              // width: "95%",
              margin: "0% ",
              position: "absolute",
              bottom: "5%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              className={style.save_button}
              style={{ backgroundColor: "#8647AF" }}
            >
              Save
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}

function bankDetailsIsEmpty() {
  return (
    <Box sx={{ padding: "1rem" }}>
      <div className={style.bankIcon}>
        <BankIcon />
      </div>
      <div className={style.emailSection}>
        <p
         className={style.emailDesc}
        >
          Please send us your bank details to Ganesh at
        </p>

        <a
          style={{
            color: "black",
            fontSize: "1.15rem",
            fontWeight: "500",
            marginTop: "0.2rem",
          }}
          href="mailto:accounts@visaero.com"
        >
          accounts@visaero.com
        </a>
      </div>
      <p className={style.bankContent}>
        We will revert with a confirmation once the account payee has been
        created successfully.
      </p>
    </Box>
  );
}
